module.exports = __webpack_public_path__ + "img/background-tasting.5da38b69.png";